import styled, { css } from 'styled-components';

import {
    Image,
    mediaMixin,
    spaceMixin,
    Spacer,
    Text,
    token,
} from '@zillow/constellation';

export const StyledGuaranteeIcon = styled(Image)`
    display: none;

    ${mediaMixin('lg', css`
        display: block;
        margin-right: ${spaceMixin('xs')};
        height: 32px;
        width: 32px;
    `)}
`;

export const StyledMiddleFlex = styled.div`
    display: flex;
    align-items: center;

    ${mediaMixin('lg', css`
        justify-content: space-between;
        flex-grow: 1;
    `)}
`;

export const StyledFlexContainer = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    ${mediaMixin('lg', css`
        flex-direction: row;
        align-items: center;
    `)}
`;

export const StyledTagSpacer = styled(Spacer)`
    margin-bottom: 6px;

    ${mediaMixin('md', css`
        margin-bottom: 0px;
    `)}
`;

export const StickyListingFooterContainer = styled.div`
    /*
     * if placeholder is visible, then changes back to fixed
     * else sticky
     */
    ${props => (props.isVisible ? (
        css`
            position: static;
            box-shadow: 0;
            border-top: 0;
        `
    ) : (
        css`
            position: fixed;
            box-shadow: 0 0 7px -2px rgba(0, 0, 0, 0), 0 0 3px 0 rgba(0, 0, 0, 0.26);
        `
    ))}
   
    border-top: 1px solid ${token('colors.gray300')};
    bottom: 0;
    left: 0;
    width: 100%;
    background: ${token('colors.white')};
    z-index: 270;
    height: 114px;
    padding: 16px;

    /* 481 */
    ${mediaMixin('md', css`
        height: 76px;
    `)}

    /* 769 */
    ${mediaMixin('lg', css`
        padding: 16px 32px;
    `)}

    /* 1024 */
    ${mediaMixin('xl', css`
        padding: 16px 40px;
    `)}

    /* 1281 */
    ${mediaMixin('xxl', css`
        padding: 17px 104px;
    `)}
`;

export const StyledText = styled(Text)`
    && {
        font-size: 12px;
        font-weight: 400;

        ${mediaMixin('lg', css`
            font-size: 14px;
            font-weight: 600;
        `)}

        /* 1024 */
        ${mediaMixin('xl', css`
            font-size: 16px;
        `)}
    }
`;
